<template>

  <HeaderSection />

  <section id="formulario">

    <Form @submit="onSubmit" :validation-schema="schema" class="space-y-4 text-gray-700 mx-5" @invalid-submit="onInvalidSubmit">

      <div class="container mx-auto max-w-7xl my-7 p-5 lg:p-8 lg:pr-10 bg-white bg-opacity-90 rounded-lg shadow-xl">

        <h1 class="font-bold text-center text-2xl">{{ $t('titulo.acreditacion.internacional')}}</h1>
        <h1 class="font-bold text-center text-xl">{{ $t('label.complete.el.form') }}</h1>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-5">
           <div class="w-full px-2 md:w-3/12">
            <label class="block mb-1">{{ $t('label.tipo.acreditado') }}</label>
            <Field name="tipoAcreditado" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.tipoAcreditado">
              <Select @blur="handleBlur" @update:model-value="handleChange" :model-value="value" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}" placeholder="Tipo" class="input-base" :options="translatedTiposAcreditados" optionLabel="value" />                
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="tipoAcreditado" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-3/12">
            <label class="block mb-1">{{ $t('label.documento') }}</label>
            <Field name="dni" v-slot="{ field, errors }" v-model="formData.dni">
              <InputText v-bind="field" type="text" @blur="validarDni" class="input-base" :placeholder="$t('label.documento')" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="dni" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-3/12">
            <label class="block mb-1">{{ $t('label.nombre') }}</label>
            <Field name="nombre" v-slot="{ field, errors }" v-model="formData.nombre">
              <InputText v-bind="field" type="text" class="input-base" :placeholder="$t('label.nombre')" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="nombre" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-3/12">
            <label class="block mb-1">{{ $t('label.apellido') }}</label>
            <Field name="apellido" v-slot="{ field,errors }" v-model="formData.apellido">
              <InputText v-bind="field" type="text" class="input-base" :placeholder="$t('label.apellido')" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="apellido" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-3/12">
              <label class="block mb-1">{{ $t('label.pais') }}</label>
              <Select v-model="selectedCountry" :options="translatedCountries" optionLabel="value" :placeholder="$t('label.pais')" class="input-base" />
          </div>
          <div class="w-full px-2 md:w-2/12">
            <label class="block mb-1">{{ $t('label.codigo.pais')}}</label>
            <InputText type="text" v-if="selectedCountry !== null" v-model="selectedCountry.code" class="input-base" readonly />
          </div>
          <div class="w-full px-2 md:w-3/12">
            <label class="block mb-1">{{ $t('label.codigo.area')}}</label>
            <Field name="codigoArea" v-slot="{ field, errors }" v-model="formData.codigoArea">
              <InputText v-bind="field" type="text" class="input-base" :placeholder="$t('label.codigo.area')" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"  />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="codigoArea" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-4/12">
            <label class="block mb-1">{{ $t('label.celular')}}</label>
            <Field name="numeroTelefono" v-slot="{ field, errors }" v-model="formData.numeroTelefono">
              <InputText v-bind="field" type="text" class="input-base" :placeholder="$t('label.celular')" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="numeroTelefono" /></span>
            </Field>
          </div>
        </div>
        
        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-6/12">
            <label class="block mb-1">{{ $t('label.empresa') }}</label>
            <Field name="empresa" v-slot="{ field,errors }" v-model="formData.empresa">
              <InputText v-bind="field" type="text" class="input-base" :placeholder="$t('label.empresa')" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="empresa" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-6/12">
            <label class="block mb-1">{{$t('label.cargo')}}</label>
            <Field name="cargo" v-slot="{ field, errors }" v-model="formData.cargo">
              <InputText v-bind="field" type="text" class="input-base" :placeholder="$t('label.cargo')" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="cargo" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-6/12">
            <label class="block mb-1">{{ $t('label.mail') }}</label>
            <Field name="mail" v-slot="{ field, errors }" v-model="formData.mail">
              <InputText v-bind="field" type="mail" class="input-base" :placeholder="$t('label.mail')" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="mail" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-6/12">
            <label class="block mb-1">{{ $t('label.empresa.expositora') }}</label>
            <Field name="empresaExpositora" v-slot="{ field, errors }" v-model="formData.empresaExpositora">
              <InputText v-bind="field" type="text" class="input-base" :placeholder="$t('label.empresa.expositora')" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="empresaExpositora" /></span>
            </Field>
          </div>
        </div>

       

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-5">
          <div class="w-full px-2 flex flex-row gap-2">
            <ToggleSwitch v-model="formData.recibirNodedades" inputId="recibirNotificaciones" />
            <label for="recibirNotificaciones" class="cursor-pointer">{{ $t('label.acepto.recibir') }}</label>
          </div>
        </div>        

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-3 mt-5">
          <div class="w-full px-2 flex flex-row gap-2">
            <ToggleSwitch v-model="formData.aceptaTerminosCondiciones" inputId="aceptaTerminosCondiciones" />
            <label for="aceptaTerminosCondiciones" class="cursor-pointer">{{ $t('label.acepta.terminos') }}</label>
          </div>
          <div class="w-full px-2 flex flex-row gap-2 text-sm">
            {{ $t('label.acepta.terminos.detalles') }}
          </div>          
        </div>        

        <div class="flex flex-wrap py-2 mt-3 jusi">
          <button type="submit" 
            class="mt-8 px-4 py-2 bg-transparent border-black hover:bg-[#00007b] text-black font-semibold hover:text-white border rounded"
            :disabled="isSubmitting">
            <i v-show="isSubmitting" class="pi pi-spin pi-spinner mr-2"></i>
            <i v-show="!isSubmitting" class="pi pi-check mr-2"></i> {{$t('boton.registrarme')}}
          </button>
        </div>
      </div>

   
      
    </Form>
   <BlockUI :blocked="isSubmitting" fullScreen />
  </section>
</template>

<script lang="ts">
import * as yup from 'yup';
import { defineComponent } from 'vue';
import { Field, Form, ErrorMessage } from 'vee-validate';
import Swal from 'sweetalert2'

import InputText from 'primevue/inputtext';
import Select from 'primevue/select';
import BlockUI from 'primevue/blockui';
import HeaderSection from '@/components/HeaderSection.vue'
import ToggleSwitch from 'primevue/toggleswitch';

import jsonCountries from '@/data/countries.json';
import jsonTipos from '@/data/tiposAcreditados.json';

import suiteService, { Acreditado,  OrigenAcreditado, TipoAcreditado } from 'qreventos-suite/services';
import {  SAVE, ORIGEN_ACREDITADO } from "qreventos-suite/constantes";
import suiteConfig from '@/services/suite.config';

interface Pais {
  code: string;
  value: string;
}


export default defineComponent({
  components: {
    HeaderSection,
    InputText, Select, ToggleSwitch,
    Field, ErrorMessage, Form, BlockUI
  },  
  data() {
    return {
      isSubmitting: false,
      paises: jsonCountries as Pais[],
      tiposAcreditados: jsonTipos as TipoAcreditado[],
      selectedCountry: { code: "+54", value: "pais.argentina" } as Pais,
      formData: {     
        dni: '',
        nombre: '',
        apellido: '',
        codigoArea: '',
        numeroTelefono: '',
        empresa:'',
        cargo:'',
        mail: '',
        empresaExpositora: '',
        aceptaTerminosCondiciones: false,
        recibirNodedades: true,
        tipoAcreditado: { id: 2055 } as TipoAcreditado
      }
    };
  }, 
  watch: {
    translatedTiposAcreditados: {
      immediate: true,
      handler(list) {
        if (!this.selectedCountry) { return; }
        const found = list.find((p: TipoAcreditado) => p.id === this.formData.tipoAcreditado.id);
        if (found) {
          this.formData.tipoAcreditado = found
        }
      }
    },
     translatedCountries: {
      immediate: true,
      handler(list) {
        if (!this.selectedCountry) { return; }
        const found = list.find((p: Pais) => p.code === this.selectedCountry.code);
        if (found) {
          this.selectedCountry = found
        }
      }
    },
  },
  computed: {
    schema() {
      return yup.object({
        dni: yup.string().required(this.$t('errors.dni.required')).min(6, this.$t('errors.dni.min')),
        nombre: yup.string().required(this.$t('errors.name.required')).min(3, this.$t('errors.name.min')),
        apellido: yup.string().required(this.$t('errors.lastname.required')).min(3, this.$t('errors.lastname.min')),
        codigoArea: yup.string().required(this.$t('errors.areaCode.required')).matches(/^\d+$/, this.$t('errors.areaCode.numeric')),
        numeroTelefono: yup.string().required(this.$t('errors.phone.required')).matches(/^\d+$/, this.$t('errors.phone.numeric')),
        mail: yup.string().required(this.$t('errors.email.required')).email(this.$t('errors.email.invalid')),
        empresa: yup.string().required(this.$t('errors.empresa.required')).min(3, this.$t('errors.empresa.min')),
        cargo: yup.string().required(this.$t('errors.cargo.required')).min(3, this.$t('errors.cargo.min')),
        empresaExpositora: yup.string().required(this.$t('errors.empresa.expositora.required')).min(3, this.$t('errors.empresa.expositora.min')),
        aceptaTerminosCondiciones: yup.boolean().oneOf([true], this.$t('errors.terminos.condiciones')),
        
      });
    },
    translatedTiposAcreditados() {
      return this.tiposAcreditados.map(tipo => ({
        id: tipo.id,
        value: this.$t(tipo.descripcion)
      }));
    },
     translatedCountries() {
      return this.paises.map(pais => ({
        code: pais.code,
        value: this.$t(pais.value)
      }));
    },
  },
  methods: {
    onInvalidSubmit(values: any) {
      const errores: number = Object.values(values?.errors || {}).flat().length;      
      Swal.fire({ title: "Error", html: this.$t("error.revise") + " " + errores, icon: "error"});
    },
    async validarDni() {
      try {
        let acreditadoExistente:Acreditado = await suiteService.findAcreditadoByFilters(suiteConfig.evento, "dni="+this.formData.dni) as Acreditado;
        if (acreditadoExistente) {
          Swal.fire({ title: this.$t('global.atencion'), html: this.$t('mensaje.dni.existe'), icon: "warning" });
          return;
        }
      } catch (error) {
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      }
    },    
    async onSubmit() {
      this.isSubmitting = true;

      try {
        let acreditadoExistente:Acreditado[] =  await suiteService.findAcreditadosByFilters(suiteConfig.evento, "dni="+encodeURIComponent(this.formData.dni) ) ;
        if (acreditadoExistente.length > 0) {
          this.isSubmitting = false;
          Swal.fire({ title: this.$t('global.atencion'), html: this.$t('mensaje.ya.acreditado'), icon: "warning" });
          return;
        }

        if (this.formData.aceptaTerminosCondiciones == false) {
          this.isSubmitting = false;
          Swal.fire({ title: this.$t('global.atencion'), html: this.$t('errors.terminos.condiciones'), icon: "error" });
          return;
        }
        
        const acreditado:Acreditado = {} as Acreditado;
        
        acreditado.tipoAcreditado = this.formData.tipoAcreditado;
        acreditado.origenAcreditado = { "id" : ORIGEN_ACREDITADO } as OrigenAcreditado;
        acreditado.nombre = this.formData.nombre;
        acreditado.apellido = this.formData.apellido;
        acreditado.dni = this.formData.dni;
        acreditado.mail = this.formData.mail;
        acreditado.telefono = this.selectedCountry.code + this.formData.codigoArea + this.formData.numeroTelefono;
        acreditado.empresa = this.formData.empresa;
        acreditado.cargo = this.formData.cargo;
        acreditado.dato2 = this.formData.empresaExpositora;

        if(this.formData.recibirNodedades) {
          acreditado.dato3 = "SI";
        } else {
          acreditado.dato3 = "NO";
        }

      
        acreditado.cantidad = 1;
        acreditado.notificar = true;
        acreditado.modificado = SAVE;

        const acreditadoActualizado: Acreditado = await suiteService.saveOrUpdate(suiteConfig.evento, acreditado);
    
        if (acreditadoActualizado) {
          this.isSubmitting = false;
          Swal.fire({ title: this.$t('global.atencion'),  html: this.$t('mensaje.ya.acreditado'), icon: "warning" }).then(() => {
            this.$router.go(0);
          });
        }
      } catch (error) {
        this.isSubmitting = false;
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      } finally {
        this.isSubmitting = false;
      }
    },
  }
});
</script>